const crypto = window.crypto || (window as unknown as { msCrypto: Crypto | undefined }).msCrypto;

/*
 * Function to generate a UUID
 * http://www.ietf.org/rfc/rfc4122.txt
 */
export function UUID(): string {
  // if secure context is available
  if (typeof crypto?.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // otherwise, fall back to pseudo-random number generation. UUID is not used for security purposes in the frontend.
  const hexDigits = '0123456789abcdef'; // Hexadecimal digits
  const s: string[] = Array(36).fill(''); // Array to hold the UUID characters

  for (let i = 0; i < 36; i++) {
    // Insert hyphens at specific positions
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      s[i] = '-';
    }
    // Set the version number to '4' at position 14
    else if (i === 14) {
      s[i] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    }
    // Generate random values for other positions
    else {
      const randomValue = Math.floor(Math.random() * 16);
      s[i] = hexDigits[i === 19 ? (randomValue & 0x3) | 0x8 : randomValue]; // bits 6-7 of the clock_seq_hi_and_reserved to 01
    }
  }

  return s.join(''); // Join the array into a string and return the UUID
}

export const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export const isUUID = (str: string) => UUID_REGEX.test(str);
